import { AxiosInstance } from 'axios';
import { ICatchIssueUseCase } from '../catch-issue.usecase';

export interface IManagerStats {
  quota_holders: number;
  networth: number;
}

export class GetStatsManagerUseCase {
  constructor(
    private readonly http: AxiosInstance,
    private readonly catchIssueUseCase: ICatchIssueUseCase
  ) {}
  async execute(managerSlug: string, adjusted: boolean = true) {
    try {
      const { data } = await this.http.get<
        Record<string, Record<string, IManagerStats>>
      >(`/asset-managers/details/${managerSlug}/stats`, {
        params: { adjusted_networth: adjusted },
      });
      return data;
    } catch (error) {
      this.catchIssueUseCase.handle({
        errorName: 'GetStatsManagerUseCase - Get Manager Stats Details',
        error,
        extras: { error, managerSlug },
      });

      return null;
    }
  }
}
